import { useEffect, useRef } from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const Loader = () => (
  <div className="flex min-h-[60vh] items-center justify-center" data-testid="page-loader">
    <div className="h-10 w-10 animate-spin rounded-full border-2 border-white/10 border-t-[#D4AF37]" />
  </div>
);

export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sid })
      .then(({ data }) => { setUser(data); navigate("/studio", { replace: true, state: { user: data } }); })
      .catch(() => { setUser(false); navigate("/login", { replace: true }); });
  }, [location.hash, navigate, setUser]);

  return <Loader />;
}

export function ProtectedRoute({ children, admin }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
